import React, { useState, useContext } from "react";
import styles from "./styles/PosCartPayment.module.css";
import DataContext from "../../../context/DataContext";
import { formatDateToLocalDate } from "../../../utils/utils";
import { calculateValues } from "../../../utils/utils";
import POSDataContext from "../../../context/POSDataContext";
import ButtonExpand from "../button_expand/ButtonExpand";
import CloseButton from "../close_button/CloseButton";
import { t } from "i18next";
import useNumberFormat from "../../../hooks/useNumberFormat";
import { ReactComponent as IconBill } from "../../../assets/bill-1.svg";

import { ReactComponent as IconPayment } from "../../../assets/payment.svg";
/**
 * SideTicket component
 */
const PosCartPayment = ({
    payment,

    currency,

    handleDelete,
}) => {
    const total = payment?.amount;
    const formatNum = useNumberFormat();

    return (
        <div
            role="button"
            className={`${styles.main_ticket_container}   flex-container`}
        >
            <div className={`${styles.info_container} v-flex-container`}>
                <div className={`${styles.ticket_info} ${styles.type_tag}`}>
                    <span>
                        <IconPayment
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {t(payment?.PaymentMethod)}
                </div>
                <div className={`${styles.ticket_info}  ${styles.amount_tag}`}>
                    <span>
                        <IconBill
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {`${currency}${formatNum(total)}`}
                </div>
            </div>
            <div className={`${styles.close_button_container} flex-container`}>
                <CloseButton
                    tab={true}
                    tabBackground={true}
                    onClickFuction={() => handleDelete(payment?.id, "ticket")}
                />
            </div>
        </div>
    );
};

export default PosCartPayment;
